import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogContent, MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

export interface TextViewDialogData {
  title?: string;
  text: string;
}

@Component({
  selector: 'app-text-view-dialog',
  templateUrl: './text-view-dialog.component.html',
  styleUrls: ['./text-view-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogContent, MatDialogTitle, MatDialogActions, MatButton],
})
export class TextViewDialogComponent {
  title: string;
  text: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TextViewDialogData,
    private readonly dialogRef: MatDialogRef<TextViewDialogComponent>,
  ) {
    this.title = data.title ?? '';
    this.text = data.text ?? '';
  }

  close(): void {
    this.dialogRef.close();
  }
}
